/* eslint-disable @typescript-eslint/ban-ts-comment */
import MyAppointments from 'pages/MyQueries'
import ChangePassword from '../../pages/ChangePassword'
// import MyOrders from '../../pages/MyOrders'
import UserOrderListAssociation from 'pages/UserOrderListAssociation'
import AssociationDocuments from '../../pages/AssociationDocuments'
import Cart from '../../pages/Cart'
import InfoPage from '../../pages/InfoPage'
import MyPatients from '../../pages/MyPatients'
import OrderDetails from '../../pages/OrderDetails'
import PatientAddresses from '../../pages/PatientAddresses'
import PatientDetails from '../../pages/PatientDetails'
import PersonalData from '../../pages/PersonalData'
import PrescriptionConfig from '../../pages/PrescriptionConfig'
import ProfessionalAddresses from '../../pages/ProfessionalAddresses'
import RegisterAddress from '../../pages/RegisterAddress'

interface PageToRenderProps {
  page?: string
}

const PAGE_TO_RENDER = {
  'perfil-alterar-senha': <ChangePassword />,
  'perfil-dados-pessoais': <PersonalData />,
  'perfil-enderecos': <ProfessionalAddresses />,
  'perfil-enderecos-novo': <RegisterAddress />,
  'perfil-config-prescricoes': <PrescriptionConfig />,
  'perfil-documentos': <AssociationDocuments />,
  'enderecos-entrega': <PatientAddresses typeOfAddress="delivery" />,
  'enderecos-cobranca': <PatientAddresses typeOfAddress="billing" />,
  'enderecos-novo': <RegisterAddress />,
  'pedidos-todos': <UserOrderListAssociation />,
  carrinho: <Cart />,
  inicio: <InfoPage />,
  consultas: <MyAppointments />,
  pacientes: <MyPatients />
  // 'pedidos-entregues': <MyOrders tab="delivered" />
}

const PageToRender = ({ page = 'inicio' }: PageToRenderProps) => {
  // @ts-ignore
  const chosenPage = PAGE_TO_RENDER[page]
  if (chosenPage) return chosenPage

  const isOrderDetailsPage = page.includes('pedidos-')
  if (isOrderDetailsPage) {
    const orderId = page.split('pedidos-')[1]
    if (orderId) return <OrderDetails orderId={orderId} />
  }

  const isProfessionalAddressesPage = page.includes('perfil-enderecos-')
  if (isProfessionalAddressesPage) {
    const addressId = page.split('perfil-enderecos-')[1]
    if (addressId) return <RegisterAddress addressId={addressId} />
  }

  const isPatientAddressesPage = page.includes('enderecos-')
  if (isPatientAddressesPage) {
    const addressId = page.split('enderecos-')[1]
    if (addressId) return <RegisterAddress addressId={addressId} />
  }

  const isMyPatientsPage = page.includes('pacientes-')
  if (isMyPatientsPage) {
    const patientId = page.split('pacientes-')[1]
    if (patientId) return <PatientDetails patientId={Number(patientId)} />
  }
  const isCartPage = page.includes('carrinho-')
  if (isCartPage) {
    return <Cart />
  }

  return <InfoPage />
}

export default PageToRender
